export default __webpack_public_path__ + "static/media/regulatory--vehicles-carrying-dangerous-goods-permitted--g1.41785cc4.png";